// extracted by mini-css-extract-plugin
module.exports = {"a-layout":"layout_a-layout__NLVVF","a-layout_main":"layout_a-layout_main__cJgBN","a-layout_canvas":"layout_a-layout_canvas__zFkEQ"};